import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/fonticons-fi': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M114.4 224h92.4l-15.2 51.2h-76.4v157.8c0 8-2.8 9.2 4.4 10l59.6 5.6v34.4h-179.2v-35.2l29.2-2.8c7.2-0.8 9.2-3.2 9.2-10.8v-155.8c0-3.2-4-3.2-8-3.2h-30.4v-51.2h38.4v-28.8c0-68 36.4-96 106-96 46.8 0 88.8 11.2 88.8 72.4l-69.6 8.4c0.4-25.6-6-31.6-22.4-31.6-25.2 0-26 13.6-26 37.6v32c0 3.2-4.8 6-0.8 6zM384 483h-140.8v-34.4l28-3.6c7.2-0.8 10.4-2.4 10.4-10v-148c0-5.6-4-9.2-9.2-10.8l-33.2-8.8 9.2-40.4h110v208c0 8-3.6 8.8 4 10l21.6 3.6v34.4zM354 135.8l12.4 45.6-10 10-42.8-22.8-42.8 22.8-10-10 12.4-45.6-30-36.4 4.8-10h38l21.2-38.4h12.8l21.2 38.4h38l4.8 13.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/fonticons-fi.js
// module id = 834
// module chunks = 0